import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { FC, ReactNode } from "react";
import { DisplayKey } from "@/models/auth";
import { useAuthChecker } from "@/hooks/useAuthChecker";

interface Props {
  handleRedirect: (path: string) => void;
  name: DisplayKey;
  path: string;
  text: string;
  children: ReactNode;
}

export const MenuItem: FC<Props> = (props) => {
  const { handleRedirect, name, path, text, children } = props;
  const { authChecker } = useAuthChecker();

  const allowRoute = authChecker(name);
  return allowRoute ? (
    <ListItemButton
      onClick={() => {
        handleRedirect(path);
      }}
    >
      <ListItemIcon>{children}</ListItemIcon>
      <ListItemText primary={text} />
    </ListItemButton>
  ) : null;
};
